import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Redirect } from 'react-router-dom';
import * as QueryString from 'query-string';
import { Container } from 'react-bootstrap';

import './Auth.css';

import { Http } from '../../support';
import { Auth } from '../../support';
import Loading from '../../facturotopia/loading/Loading';
import ResponseError from '../../shared/responses/ResponseError';

class ReceptoresSignInVerify extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      busy: false,
      restored: false,
      isLoggedIn: false,
      validator: new Validator({}, this.rules)
    };
  }

  componentDidMount() {
    this.verify();
  }

  verify = async () => {
    this.setState({
      busy: true
    });

    try {
      const { search = '' } = this.props.location || {};

      const query = QueryString.parse(this.props.location.search);

      this.setState({
        busy: true
      });

      const headers = {
        'X-Tenancy': query.tenancy
      }

      const response = await Http.post(`/receptores/auth/verify${search}`, {}, { headers })

      const { access_token, cliente, empresa, ...rest } = response;

      const user = {
        ...rest,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const data = {
        tenancy: query.tenancy,
        token: { access_token },
        user,
        empresa: empresa || {},
        emisor: {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setState({
        isLoggedIn: true,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  render() {
    const {
      isLoggedIn,
      busy
    } = this.state;

    // const { onForgotPasswordClick } = this.props;

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/ext/receptores/facturas' } };

      if (from.pathname === '/ext/receptores/auth/login') {
        from.pathname = '/ext/receptores/facturas';
      }

      return <Redirect to="/bridge/receptores" state={ from } />;
    }

    return (
      <Container fluid={ true } className={ `app-wrapper` }>
        { !busy && <Loading /> }
        <span>Estamos verificando tu inicio de sesión</span>
      </Container>
      )
    }
  }

  export default ReceptoresSignInVerify;